import { useState, useEffect, useRef } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);

  const navLinks = [
    { name: "Студио", href: "#tech" },
    { name: "Снимки", href: "#gallery" },
    { name: "Услуги", href: "#services" },
    { name: "Контакти", href: "#contact" },
  ];

  // Close menu on outside click
  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    }
    if (isOpen) document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  return (
    <div className="bg-white sticky w-full shadow-sm z-[999] top-0 ">
    <motion.nav
      className="page_width mb-8 border-b border-border lg:border-none z-20 py-8 flex justify-between items-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
    >
      {/* Logo */}

      {/* Desktop Navigation */}
      <a href="/" className="text-2xl mr-8 font-extrabold">
        Storycast
      </a>
      <ul className="hidden lg:flex items-center gap-4 flex-grow">
        {navLinks.map((link, index) => (
          <a
            key={index}
            href={link.href}
            className="relative font-main text-sm 
              after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[2px] 
              after:bg-black after:transition-all after:duration-300 hover:after:w-full"
          >
            {link.name}
          </a>
        ))}
      </ul>
      <a
        href="#contact"
        className="hidden lg:block relative overflow-hidden border-2 border-black rounded-full py-3 px-8 text-sm text-black transition-all duration-500 before:absolute before:inset-0 before:bg-black before:translate-x-[-100%] before:transition-transform before:duration-500 hover:text-white hover:before:translate-x-0"
      >
        <span className="relative z-10">Свържи се с нас</span>
      </a>

      {/* Mobile Menu Button */}
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="lg:hidden w-10 h-10 flex text-4xl items-center justify-center"
        aria-label="Open menu"
        aria-expanded={isOpen}
      >
        ☰
      </button>

      {/* Mobile Menu */}
      <AnimatePresence>
        {isOpen && (
          <>
            {/* Overlay */}
            <motion.div
              className="fixed inset-0 z-30"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              exit={{ opacity: 0 }}
              onClick={() => setIsOpen(false)}
            />
            {/* Sidebar Menu */}
            <motion.div
              ref={menuRef}
              className="fixed border-l right-0 top-0 w-3/4 h-full bg-secondary shadow-lg z-40 flex flex-col p-6"
              initial={{ x: "100%" }}
              animate={{ x: 0 }}
              exit={{ x: "100%" }}
              transition={{ type: "spring", stiffness: 200, damping: 20 }}
            >
              {/* Close Button */}
              <button
                className="self-end text-2xl mb-6"
                onClick={() => setIsOpen(false)}
                aria-label="Close menu"
              >
                ✕
              </button>
              {/* Navigation Links */}
              {navLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.href}
                  className="relative font-main text-base text-black my-4"
                >
                  {link.name}
                </a>
              ))}
              {/* CTA Button */}
              <a
                href="#contact"
                className="lg:hidden text-center bg-black rounded-full mt-4 py-4 px-8 text-sm text-white"
                onClick={() => setIsOpen(false)}
              >
                Свържи се с нас
              </a>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </motion.nav>
    </div>
  );
}
